import React, { useReducer } from 'react'
import { Box, styled } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import PeopleSearch from '../Filters/PeopleSearch'
import Button from '../Button'
import { isNilOrEmpty } from 'packages/core'
import { mobileScreenWidth } from 'utils'
import { useCurrentPerson } from 'hooks'

const styles = {
    peopleSearch: {
        '& > div': {
            border: 'solid 1px #ebebed',
            '&:hover': {
                borderColor: '#307fc1',
            },
            padding: '1.5px !important',
            '& > div': {
                right: '0px !important',
                pointerEvents: 'none',
            },
            '& > input': {
                height: '35px',
                cursor: 'pointer',
                width: 'auto !important',
            },
        },
    },

    cancelButton: {
        backgroundColor: '#ffffff !important',
        color: '#307fc1 !important',
        boxShadow: 'none',
        border: '1px solid #307fc1',
    },
}

const ItemContainer = styled(Box)({
    padding: '15px 0px',
    [`@media (max-width:${mobileScreenWidth})`]: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
})

const reducers = (state, { type, payload }) => {
    switch (type) {
        case 'SET_PERSON':
            return { ...state, person: payload }

        case 'SET_DELEGATE_FOREVER':
            return { ...state, delegateForever: payload }

        case 'CLEAR_STATE':
            return {
                ...payload,
            }
        default:
            return state
    }
}

const AssignTaskForm = ({ onSave, isSaving, onCancel }) => {
    const [state, dispatch] = useReducer(reducers, {
        person: null,
    })

    const { t } = useTranslation()

    const { data: currentPerson } = useCurrentPerson()

    return (
        <>
            <ItemContainer>
                <PeopleSearch
                    endAdornmentComponent={() => <></>}
                    label={t('MyTasks_PersonName')}
                    placeholder={t('MyTasks_SelectPerson')}
                    onChange={(_, value) =>
                        dispatch({
                            type: 'SET_PERSON',
                            payload: value,
                        })
                    }
                    url="/api/people/approvers"
                    rootStyleProps={styles.peopleSearch}
                    value={state.person}
                    excludeOptions={[currentPerson.id]}
                    debounceInterval={700}
                />
            </ItemContainer>

            <ItemContainer
                display="flex"
                marginLeft="-8px"
                flexDirection="row !important"
                flexWrap="wrap"
            >
                <Button.Rounded
                    disabled={isNilOrEmpty(state.person) || isSaving}
                    isLoading={isSaving}
                    onClick={() => {
                        onSave(state)
                    }}
                >
                    {t('MyTasks_AssignThisTask')}
                </Button.Rounded>

                <Button.Rounded onClick={onCancel} styles={styles.cancelButton}>
                    {t('MyTasks_Cancel')}
                </Button.Rounded>
            </ItemContainer>
        </>
    )
}

export default AssignTaskForm
